
import storeDateSelectorResolve from '../../directive/store-date-selector/store-date-selector.resolve';

export default function routes($stateProvider) {
	$stateProvider
		.state('summaryPage', {
			url: '/summary/:stores?startDate&endDate',
			template: require('./summary.html'),
			resolve: {
				...storeDateSelectorResolve,
				summary: ['loggedIn', 'Stats', 'selectedStore', 'endDate', 'startDate', function (loggedIn, Stats, selectedStore, endDate, startDate) {
					return Stats.summary({
						stores: JSON.stringify(selectedStore.storeIds),
						startDate,
						endDate,
					});
				}],
			},
			controller: 'SummaryController',
			controllerAs: 'summary'
		});
}

routes.$inject = ['$stateProvider'];



// WEBPACK FOOTER //
// ./src/page/summary/summary.routes.js